import React, {useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
// local
import AgreementCardSwitch from "./components/AgreementCardSwitch";
import {dateFormat} from "helpers/datetime";
import {getFullName} from "helpers/helper";
import {IconCheckpoint} from "components/icons";
import {hashes} from "constants/tabs.const";

const MarkingsCard = ({ourMarkings, orgMarkings, isAdminOwner, onUpdate}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const markings = useMemo(
    () =>
      orgMarkings?.map((item) => ({
        ...ourMarkings?.find((marking) => marking.MarkingId === item.id),
        ...item,
      })),
    [ourMarkings, orgMarkings]
  );
  const handleUpdate = (checked, markingId) =>
    onUpdate(
      checked
        ? [...ourMarkings.map(({MarkingId}) => MarkingId), markingId]
        : ourMarkings.map(({MarkingId}) => MarkingId).filter((id) => id !== markingId)
    );

  const toSettings = () => navigate({hash: hashes.SETTINGS});

  const MarkingRow = ({marking}) => {
    const fullName = getFullName(
      marking.OrganizationMember?.User?.firstName,
      marking.OrganizationMember?.User?.lastName
    );
    const date = dateFormat(marking.updatedAt);
    const info = t("OUR_CHECKPOINTS_ITEM_INFO").format(fullName, date);

    return (
      <div className="df-row-center mt-4">
        {isAdminOwner && <IconCheckpoint name={marking.name} addClass="mr-2" />}
        <AgreementCardSwitch
          isAdminOwner={isAdminOwner}
          checked={ourMarkings?.find(({MarkingId}) => MarkingId === marking.id)}
          onClick={(checked) => handleUpdate(checked, marking.id)}
          activeLabel={marking.description}
          inactiveLabel={marking.description}
          inactiveMemberLabel={marking.description}
          extraIcon={<IconCheckpoint name={marking.name} addClass="mr-2" />}
        />
        {!!marking.OrganizationMember && (
          <span className="__italic mid-gray mla">{info}</span>
        )}
      </div>
    );
  };

  const NoMarkings = () => (
    <div className="__italic pt-4">
      <span>{t("OUR_CHECKPOINTS_NO_MARKINGS")}</span>
      <span className="link cpointer pl-1" onClick={toSettings}>
        {t("OUR_CHECKPOINTS_NO_MARKINGS_LINK")}
      </span>
    </div>
  );

  return (
    <div className="agreement-card">
      <h3 className="agreement-card__title __uppercase">{t("OUR_CHECKPOINTS_TITLE")}</h3>
      <div className="agreement-card__body pl-4 pr-4 pt-0 pb-4">
        {markings?.length ? (
          markings.map((item) => <MarkingRow key={item.id} marking={item} />)
        ) : (
          <NoMarkings />
        )}
      </div>
    </div>
  );
};

export default MarkingsCard;
